import { _ as r } from "../internals/export.js";
import { i as t } from "../internals/is-pure.js";
import { d as e } from "../internals/descriptors.js";
import { g as o } from "../internals/global.js";
import { p as s } from "../internals/path.js";
import { f as i } from "../internals/function-uncurry-this.js";
import { i as n } from "../internals/is-forced.js";
import { h as a } from "../internals/has-own-property.js";
import { i as p } from "../internals/inherit-if-required.js";
import { o as m } from "../internals/object-is-prototype-of.js";
import { i as f } from "../internals/is-symbol.js";
import { t as l } from "../internals/to-primitive.js";
import { f as c } from "../internals/fails.js";
import "../internals/object-get-own-property-names.js";
import "../internals/object-get-own-property-descriptor.js";
import "../internals/object-define-property.js";
import { t as u } from "../internals/this-number-value.js";
import { s as j } from "../internals/string-trim.js";
import { __exports as b } from "../../../_virtual/object-get-own-property-names.js";
import { __exports as N } from "../../../_virtual/object-define-property.js";
import { __exports as g } from "../../../_virtual/object-get-own-property-descriptor.js";
var I = b.f,
  _ = g.f,
  y = N.f,
  h = j.trim,
  v = "Number",
  E = o[v];
s[v];
var d = E.prototype,
  w = o.TypeError,
  A = i("".slice),
  S = i("".charCodeAt),
  T = function T(r) {
    var t = l(r, "number");
    return "bigint" == typeof t ? t : F(t);
  },
  F = function F(r) {
    var t,
      e,
      o,
      s,
      i,
      n,
      a,
      p,
      m = l(r, "number");
    if (f(m)) throw w("Cannot convert a Symbol value to a number");
    if ("string" == typeof m && m.length > 2) {
      if (43 === (t = S(m = h(m), 0)) || 45 === t) {
        if (88 === (e = S(m, 2)) || 120 === e) return NaN;
      } else if (48 === t) {
        switch (S(m, 1)) {
          case 66:
          case 98:
            o = 2, s = 49;
            break;
          case 79:
          case 111:
            o = 8, s = 55;
            break;
          default:
            return +m;
        }
        for (a = 0, n = (i = A(m, 2)).length; a < n; a++) if ((p = S(i, a)) < 48 || p > s) return NaN;
        return parseInt(i, o);
      }
    }
    return +m;
  },
  x = n(v, !E(" 0o1") || !E("0b1") || E("+0x1")),
  M = function M(r) {
    var t,
      e = arguments.length < 1 ? 0 : E(T(r));
    return (t = this, m(d, t) && c(function () {
      u(t);
    })) ? p(Object(e), this, M) : e;
  };
M.prototype = d, x && !t && (d.constructor = M), r({
  global: !0,
  constructor: !0,
  wrap: !0,
  forced: x
}, {
  Number: M
}), (x || t) && function (r, t) {
  for (var o, s = e ? I(t) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), i = 0; s.length > i; i++) a(t, o = s[i]) && !a(r, o) && y(r, o, _(t, o));
}(s[v], E);